/**
 * ErrorState Component
 * 
 * Displays an error message with retry option.
 * Used when data fetching fails.
 */

import React from 'react';
import { AlertCircle } from 'lucide-react';

export interface ErrorStateProps {
  /** Error title */
  title?: string;
  /** Error message */
  message: string;
  /** Retry callback */
  onRetry?: () => void;
}

export function ErrorState({
  title = 'Error loading data',
  message,
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="text-center py-12">
      <div className="text-red-600 mb-4">
        <AlertCircle className="w-12 h-12 mx-auto mb-2" />
        <p className="text-lg font-medium">{title}</p>
        <p className="text-sm text-gray-600 mt-1">{message}</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Try Again
        </button>
      )}
    </div>
  );
}
